const adminRoutes = [
  {
    name: 'dashboard',
    icon: 'dashboard',
    url: 'dashboard',
    id: 'dashboard_01',
  },
  {
    name: 'media.library',
    icon: 'fiImage',
    url: 'media-library',
    id: 'media_library',
  },
  {
    name: 'inventory',
    icon: 'stock',
    url: 'inventory',
    id: 'inventory_management',
  },
  {
    name: 'tasks',
    icon: 'orderedList',
    url: 'tasks',
    id: 'tasks_board',
  },
  {
    name: 'order',
    id: 'order.management',
    icon: 'fiShoppingCart',
    submenu: [
      {
        name: 'all.orders',
        icon: 'fiShoppingCart',
        url: 'orders',
        id: 'orders-list-all',
        children: [],
      },
      {
        name: 'tracking.system',
        icon: 'fiShoppingCart',
        url: 'tracking',
        id: 'tracking',
        children: [],
      },
      {
        name: 'refunds',
        icon: 'fiShoppingCart',
        url: 'refunds',
        id: 'refunds_list',
        children: [],
      },
    ],
  },
  {
    name: 'product',
    id: 'food.management',
    icon: 'branches',
    submenu: [
      {
        name: 'products',
        icon: 'dropbox',
        url: 'catalog/products',
        id: 'food',
        children: [],
      },
      {
        name: 'extras',
        icon: 'branches',
        url: 'catalog/extras/list',
        id: 'extras',
        children: [
          {
            name: 'extra.group',
            icon: 'groupOutlined',
            url: 'catalog/extras',
            id: 'extra.group',
          },
          {
            name: 'extra.value',
            icon: 'unGroupOutlined',
            url: 'catalog/extras/value',
            id: 'extra.value',
          },
        ],
      },
      {
        name: 'properties',
        icon: 'branches',
        url: 'catalog/properties/list',
        id: 'properties',
        children: [
          {
            name: 'properties.group',
            icon: 'groupOutlined',
            url: 'catalog/properties',
            id: 'properties.group',
          },
          {
            name: 'properties.value',
            icon: 'unGroupOutlined',
            url: 'catalog/properties/value',
            id: 'properties.value',
          },
        ],
      },
      {
        name: 'categories',
        icon: 'appStore',
        url: 'catalog/categories',
        id: 'categories',
        children: [],
      },
      {
        name: 'brands',
        icon: 'star',
        url: 'catalog/brands',
        id: 'brands',
        children: [],
      },
      {
        name: 'labels',
        icon: 'GiftOutlined',
        url: 'catalog/labels',
        id: 'labels',
        children: [],
      },
      {
        name: 'reviews',
        icon: 'star',
        url: 'reviews',
        id: 'reviews',
        children: [],
      },
      {
        name: 'product.reviews',
        icon: 'star',
        url: 'reviews/product',
        id: 'reviews_product',
        children: [],
      },
      {
        name: 'purchase.counters',
        icon: 'appStore',
        url: 'catalog/purchase-counters',
        id: 'purchase_counters',
        children: [],
      },
      {
        name: 'order.reviews',
        icon: 'star',
        url: 'reviews/order',
        id: 'reviews_order',
        children: [],
      },
    ],
  },
  {
    name: 'used',
    id: 'used.management',
    icon: 'appStore',
    submenu: [
      {
        name: 'used.products',
        icon: 'dropbox',
        url: 'used/products',
        id: 'used_products',
        children: [],
      },
      {
        name: 'used.categories',
        icon: 'appStore',
        url: 'used/categories',
        id: 'used_categories',
        children: [],
      },
    ],
  },
  {
    name: 'content',
    id: 'content.management',
    icon: 'appStoreAdd',
    submenu: [
      {
        name: 'banners',
        icon: 'bsImage',
        url: 'banners',
        id: 'banners',
        children: [],
      },
      {
        name: 'blogs',
        url: 'blogs',
        icon: 'form',
        id: 'blogs_02',
        children: [],
      },
      {
        name: 'stories',
        icon: 'BsClockHistory',
        url: 'stories',
        id: 'stories',
        children: [],
      },
      {
        name: 'notifications',
        icon: 'notificationsActive',
        url: 'notifications',
        id: 'notifications',
        children: [],
      },
      {
        name: 'notification.inbox',
        icon: 'message',
        url: 'notifications/inbox',
        id: 'notifications_inbox',
        children: [],
      },
      {
        name: 'notice.board',
        icon: 'message',
        url: 'content/notice-board',
        id: 'notice_board',
        children: [],
      },
      {
        name: 'team.members',
        icon: 'user',
        url: 'content/team-members',
        id: 'team_members',
        children: [],
      },
    ],
  },
  {
    name: 'storefront',
    id: 'storefront',
    icon: 'shop',
    submenu: [
      {
        name: 'home.layout',
        icon: 'orderedList',
        url: 'storefront/home-layout',
        id: 'storefront_home_layout',
        children: [],
      },
      {
        name: 'used.homescreen',
        icon: 'thunderbolt',
        url: 'storefront/home-layout-used',
        id: 'storefront_home_layout_used',
        children: [],
      },
      {
        name: 'header.quick.actions',
        icon: 'thunderbolt',
        url: 'storefront/header-quick-actions',
        id: 'storefront_header_quick_actions',
        children: [],
      },
      {
        name: 'gallery',
        icon: 'bsImage',
        url: 'gallery',
        id: 'gallery_list',
        children: [],
      },
    ],
  },
  {
    name: 'repair',
    id: 'repair.management',
    icon: 'tool',
    submenu: [
      {
        name: 'repair.companies',
        icon: 'star',
        url: 'repair/companies',
        id: 'repair_companies',
        children: [],
      },
      {
        name: 'repair.device.models',
        icon: 'laptop',
        url: 'repair/device-models',
        id: 'repair_device_models',
        children: [],
      },
      {
        name: 'repair.services',
        icon: 'branches',
        url: 'repair/services',
        id: 'repair_services',
        children: [],
      },
      {
        name: 'repair.featured.services',
        icon: 'trophy',
        url: 'repair/featured-services',
        id: 'repair_featured_services',
        children: [],
      },
      {
        name: 'repair.banners',
        icon: 'bsImage',
        url: 'repair/banners',
        id: 'repair_banners',
        children: [],
      },
      {
        name: 'repair.schedule',
        icon: 'calendar',
        url: 'repair/schedule-settings',
        id: 'repair_schedule',
        children: [],
      },
      {
        name: 'repair.bookings',
        icon: 'fiShoppingCart',
        url: 'repair/bookings',
        id: 'repair_bookings',
        children: [],
      },
    ],
  },
  {
    name: 'trade.in',
    id: 'trade_in.management',
    icon: 'euroCircle',
    submenu: [
      /*
       * Brands, Variants, Condition grades and Prices are not listed here.
       *
       * Brands and variants are both managed inside Devices, which is one
       * page holding the whole catalogue: brands as collapsible groups,
       * devices under them, and variants added inline with their prices. Two
       * more sidebar entries onto the same records only invited the shop to
       * edit the same thing in two places.
       *
       * Condition grades and Prices belong to the older flow, where a
       * customer picked one of three condition grades and the offer came
       * from a price table. The storefront asks the questionnaire instead and
       * calls neither. Their routes and data are left untouched, so nothing
       * is lost and the pages still open if anybody has one bookmarked.
       */
      {
        name: 'trade.in.devices',
        icon: 'laptop',
        url: 'trade-in/device-models',
        id: 'trade_in_device_models',
        children: [],
      },
      {
        name: 'trade.in.device.types',
        // `appStore`, not `appstore`: helpers/getSystemIcons matches the name
        // exactly and returns nothing for one that is not in its list, which is
        // why this row sat in the menu with a blank where its icon goes.
        icon: 'appStore',
        url: 'trade-in/device-types',
        id: 'trade_in_device_types',
        children: [],
      },
      {
        name: 'trade.in.questions',
        icon: 'orderedList',
        url: 'trade-in/questions',
        id: 'trade_in_questions',
        children: [],
      },
      {
        name: 'trade.in.settings',
        icon: 'settings',
        url: 'trade-in/settings',
        id: 'trade_in_settings',
        children: [],
      },
      {
        name: 'trade.in.requests',
        icon: 'fiShoppingCart',
        url: 'trade-in/requests',
        id: 'trade_in_requests',
        children: [],
      },
    ],
  },
  {
    /*
      The shop's own people, deliberately not under "Customer".

      A staff account is not a customer record with a different flag on it: it
      carries a role, it is what the permission checks read, and none of the
      customer screens — spend, orders, acquisition, online status — say
      anything about one. Keeping them in the same section invited exactly the
      confusion of two entries both called "Users".
    */
    name: 'staff',
    id: 'staff.management',
    icon: 'userGroupAdd',
    submenu: [
      {
        name: 'admin.users',
        icon: 'userGroupAdd',
        url: 'users/admin',
        id: 'userGroupAdd',
        children: [],
      },
      {
        name: 'roles',
        icon: 'settings',
        url: 'users/roles',
        id: 'staff_roles',
        children: [],
      },
    ],
  },
  {
    name: 'customer',
    id: 'customer.management_02',
    icon: 'wallet',
    submenu: [
      {
        name: 'customers',
        icon: 'user',
        url: 'users/user',
        id: 'user',
        children: [],
      },
      {
        name: 'subscriber',
        icon: 'MdNotificationAdd',
        url: 'subscriber',
        id: 'subscriber',
        children: [],
      },
      {
        // The customer support inbox. The page has always existed at
        // /messages but had no way into it from the sidebar, so the only
        // people who found it were the ones who knew the URL.
        name: 'support.chat',
        icon: 'MdNotificationAdd',
        url: 'messages',
        id: 'support_messages',
        children: [],
      },
      {
        name: 'live.chat',
        icon: 'message',
        url: 'chat',
        id: 'live_chat',
        children: [],
      },
    ],
  },
  {
    name: 'marketing',
    id: 'restaurant.management_05',
    icon: 'copyright',
    submenu: [
      {
        name: 'coupons',
        icon: 'calendar',
        url: 'coupons',
        id: 'coupons',
        children: [],
      },
      {
        name: 'special.offers',
        icon: 'calendar',
        url: 'special-offers',
        id: 'special_offers',
        children: [],
      },
      {
        name: 'popups',
        icon: 'notificationsActive',
        url: 'marketing/popups',
        id: 'marketing_popups',
        children: [],
      },
      {
        // The wording of everything the app sends by itself. A fixed list of
        // events, so it is an editing screen rather than a create/delete one.
        name: 'push.notifications',
        icon: 'notificationsActive',
        url: 'marketing/push/templates',
        id: 'push_templates',
        children: [],
      },
      {
        // Pushes the shop writes and sends itself.
        name: 'push.campaigns',
        icon: 'mail',
        url: 'marketing/push/campaigns',
        id: 'push_campaigns',
        children: [],
      },
      {
        // Every phone registered for notifications, searchable.
        name: 'app.devices',
        icon: 'products',
        url: 'marketing/push/devices',
        id: 'push_devices',
        children: [],
      },
      {
        name: 'message.subscribers',
        icon: 'mail',
        url: 'message/subscriber',
        id: 'message_subscribers',
        children: [],
      },
    ],
  },
  {
    name: 'analytics.and.reports',
    id: 'analytics',
    icon: 'products',
    submenu: [
      {
        name: 'analytics.landing',
        icon: 'overview',
        url: 'analytics',
        id: 'analytics_landing',
        children: [],
      },
      {
        name: 'products',
        icon: 'products',
        url: 'report/products',
        id: 'report-products',
        children: [],
      },
      {
        name: 'order',
        icon: 'orders',
        url: 'report/orders',
        id: 'report-orders',
        children: [],
      },
      {
        name: 'stock',
        icon: 'stock',
        url: 'report/stock',
        id: 'report-stock',
        children: [],
      },
      {
        name: 'category',
        icon: 'categories',
        url: 'report/categories',
        id: 'report-categories',
        children: [],
      },
      {
        name: 'overview',
        icon: 'overview',
        url: 'report/overview',
        id: 'report-overview',
        children: [],
      },
      {
        name: 'revenue',
        icon: 'revenue',
        url: 'report/revenue',
        id: 'report-revenue',
        children: [],
      },
      {
        name: 'acquisition.title',
        icon: 'revenue',
        url: 'report/acquisition',
        id: 'report-acquisition',
        children: [],
      },
      {
        name: 'retention.title',
        icon: 'revenue',
        url: 'report/retention',
        id: 'report-retention',
        children: [],
      },
      {
        name: 'search.terms.title',
        icon: 'revenue',
        url: 'report/search-terms',
        id: 'report-search-terms',
        children: [],
      },
      {
        name: 'engagement.title',
        icon: 'revenue',
        url: 'report/product-engagement',
        id: 'report-product-engagement',
        children: [],
      },
      {
        name: 'carts.title',
        icon: 'revenue',
        url: 'report/abandoned-carts',
        id: 'report-abandoned-carts',
        children: [],
      },
      {
        name: 'extras.and.variations',
        icon: 'variation',
        url: 'report/extras-variations',
        id: 'report-extras-variations',
        children: [],
      },
      {
        name: 'variations',
        icon: 'variation',
        url: 'report/variation',
        id: 'report-variation',
        children: [],
      },
    ],
  },
  {
    name: 'business.settings',
    id: 'business.settings_02',
    icon: 'settings',
    submenu: [
      {
        name: 'settings.general',
        icon: 'settings',
        url: 'settings/general',
        id: 'settings.general_02',
        children: [],
      },
      {
        name: 'seo.settings',
        icon: 'settings',
        url: 'settings/seo',
        id: 'settings.seo_02',
        children: [],
      },
      {
        // Scheduled tasks — Google reviews sync, expired-row cleanup, etc.
        // Lets an admin run one now (bypassing the cron interval) and
        // change how often each fires without a redeploy.
        name: 'cron.jobs',
        icon: 'clock',
        url: 'settings/cron-jobs',
        id: 'settings.cronJobs_02',
        children: [],
      },
      {
        // Manual "Sync now" for the Google reviews shown on the storefront home
        // page. The schedule itself lives under Cron jobs above; this is the
        // on-demand trigger for when a new review should appear immediately.
        name: 'google.reviews.settings',
        icon: 'settings',
        url: 'settings/google-reviews',
        id: 'settings.googleReviews_02',
        children: [],
      },
      {
        name: 'payments',
        icon: 'wallet',
        url: 'settings/payments',
        id: 'payments',
        children: [],
      },
      {
        name: 'page.setup',
        icon: 'settings',
        url: 'settings',
        id: 'page.setup',
        children: [
          {
            name: 'faq',
            icon: 'questionCircle',
            url: 'settings/faqs',
            id: 'faq',
          },
          {
            name: 'legal.documents',
            icon: 'FileTextOutlined',
            url: 'settings/legal',
            id: 'legal_documents',
          },
        ],
      },
    ],
  },
  {
    name: 'system.settings',
    id: 'system.settings_01',
    icon: 'global',
    submenu: [
      {
        name: 'system.information',
        icon: 'tool',
        url: 'settings/system-information',
        id: 'settings/system-informations_tool_01',
        children: [],
      },
      {
        name: 'email.logs',
        icon: 'mail',
        url: 'settings/email-logs',
        id: 'settings/email-logs_mail_01',
        children: [],
      },
      {
        name: 'whatsapp.logs',
        icon: 'message',
        url: 'settings/whatsapp',
        id: 'settings/whatsapp_message_01',
        children: [],
      },
      {
        name: 'email.previews',
        icon: 'mail',
        url: 'settings/email-previews',
        id: 'settings/email-previews_mail_01',
        children: [],
      },
      {
        name: 'system.update',
        icon: 'tool',
        url: 'settings/update',
        id: 'settings_update',
        children: [],
      },
      {
        name: 'cash.clear',
        icon: 'wallet',
        url: 'settings/cashClear',
        id: 'settings_cash_clear',
        children: [],
      },
    ],
  },
  {
    name: 'logout',
    icon: 'logout',
    url: '',
    id: 'logout_04',
  },
];

export const data = {
  admin: adminRoutes,
};